@if (currentStepId() === 'create-territory') {
    @if (currentSubStepIndex() === 0) {
        <div class="create-territory">
            <app-territory-map
                #territoryMapRef
                [autoCenter]="false"
                (onDone)="onDone($event)"
                (onDelete)="onDelete()"></app-territory-map>
        </div>
    } @else {
        <app-name-territory #nameTerritoryRef></app-name-territory>
    }
}
